import { MANAGED_SUBSTANCE_CLAIMS } from './substance-declaration-claims'

const RegulationVisibilityDecision = Object.freeze({
    SHOW: 'show',
    HIDE: 'hide',
    ABSTAIN: 'abstain',
})

const normalizeKey = value => (
    typeof value === 'string' ? value.trim().toLowerCase() : ''
)

const isRegulation = (regulation, key) => (
    normalizeKey(regulation && regulation.key) === key
)

const hasDocumentScipNumber = scipInformation => !!(
    scipInformation
    && typeof scipInformation.scipNumber === 'string'
    && scipInformation.scipNumber.trim()
)

const hasUnambiguousDeclaration = (regulation, declaration) => {
    const managedClaims = (Array.isArray(regulation && regulation.claims)
        ? regulation.claims
        : [])
        .filter(claim => claim && MANAGED_SUBSTANCE_CLAIMS.includes(claim.type))

    return managedClaims.length === 1 && managedClaims[0].type === declaration
}

const showScipWithDocumentNumber = ({ regulation, scipInformation }) => (
    isRegulation(regulation, 'scip') && hasDocumentScipNumber(scipInformation)
        ? RegulationVisibilityDecision.SHOW
        : RegulationVisibilityDecision.ABSTAIN
)

const hideScipForReachWithoutRestrictedSubstances = ({ regulation, legislations }) => {
    if (!isRegulation(regulation, 'scip')) {
        return RegulationVisibilityDecision.ABSTAIN
    }

    const reach = (Array.isArray(legislations) ? legislations : [])
        .find(item => isRegulation(item, 'reach'))

    return hasUnambiguousDeclaration(reach, 'does_not_contain_restricted_substances')
        ? RegulationVisibilityDecision.HIDE
        : RegulationVisibilityDecision.ABSTAIN
}

const BUILT_IN_POLICIES = Object.freeze({
    'show-scip-with-document-number-v1': showScipWithDocumentNumber,
    'hide-scip-for-reach-without-restricted-substances-v1':
        hideScipForReachWithoutRestrictedSubstances,
})

const createRegulationVisibilityPolicyRegistry = ({ policies = {} } = {}) => {
    const registered = Object.freeze({ ...BUILT_IN_POLICIES, ...policies })

    return Object.freeze({
        evaluate(policyNames, context = {}) {
            const names = Array.isArray(policyNames) ? policyNames : []

            for (let index = 0; index < names.length; index += 1) {
                const policy = registered[names[index]]
                if (typeof policy !== 'function') {
                    continue
                }

                const decision = policy(context)
                if (decision === RegulationVisibilityDecision.SHOW
                    || decision === RegulationVisibilityDecision.HIDE) {
                    return { decision, policy: names[index] }
                }
            }

            return { decision: RegulationVisibilityDecision.SHOW, policy: null }
        },
        isVisible(policyNames, context = {}) {
            return this.evaluate(policyNames, context).decision
                !== RegulationVisibilityDecision.HIDE
        },
    })
}

const regulationVisibilityPolicyRegistry = createRegulationVisibilityPolicyRegistry()

export {
    RegulationVisibilityDecision,
    createRegulationVisibilityPolicyRegistry,
    regulationVisibilityPolicyRegistry,
}

export default regulationVisibilityPolicyRegistry
